// Setup event-listeners for checkbox-cards and radio-cards
window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.checkbox-card input[type="checkbox"],.radio-card input[type="radio"]').forEach(el => {
    if (el.checked) {
      el.closest('.control').classList.add('checked');
    } else {
      el.closest('.control').classList.remove('checked');
    }
  });
  document.querySelectorAll('.checkbox-card input[type="checkbox"]').forEach(el => {
    el.addEventListener('change', event => {
      event.target.closest('.control').classList.toggle('checked');
    });
  });
  document.querySelectorAll('.checkbox-card').forEach(el => {
    el.addEventListener('click', setCheckboxCards);
  });
  document.querySelectorAll('.radio-card').forEach(el => {
    el.addEventListener('click', setRadioCards);
  });
});

function setCheckboxCards(event) {
  const blacklist = ['input', 'label', 'textarea', 'select', 'button', 'a'];
  const isIgnored = event.composedPath().filter(el => {
    return blacklist.includes(String(el.tagName).toLowerCase());
  });
  if (!isIgnored.length) {
    const thisInputEl = this.querySelector('input[type="checkbox"]');
    this.classList.toggle('checked');
    thisInputEl.checked = !thisInputEl.checked;
  }
}

function setRadioCards(event) {
  const blacklist = ['input', 'textarea', 'select', 'button', 'a'];
  const isInput = event.composedPath().filter(el => {
    return blacklist.includes(String(el.tagName).toLowerCase() && el.type !== 'radio');
  });
  if (!isInput.length) {
    let thisInputEl;
    if (this.type === 'radio') {
      thisInputEl = this;
    } else {
      thisInputEl = this.querySelector('input[type="radio"]');
    }
    document.querySelectorAll(`input[type="radio"][name="${thisInputEl.name}"]`).forEach(el => {
      if (el == thisInputEl) {
        el.checked = true;
        el.closest('.control').classList.add('checked');
      } else {
        el.checked = false;
        el.closest('.control').classList.remove('checked');
      }
    });
  }
}
